import { render, staticRenderFns } from "./deleteService.vue?vue&type=template&id=2dcec934&scoped=true"
import script from "./deleteService.vue?vue&type=script&lang=js"
export * from "./deleteService.vue?vue&type=script&lang=js"
import style0 from "./deleteService.vue?vue&type=style&index=0&id=2dcec934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcec934",
  null
  
)

export default component.exports